import _defineProperty from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _extends from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: translateY(-50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { Flex, Text, LinkButton, useTheme, styled, IconClubCatch, Span, IconClubCatchShipping, IconClubCatchMonitor, IconDiscountTag, IconClubCatchMail, Link } from "@catchoftheday/cg-components";
import useSWR from "swr";
import { SpanWithAfterDownArrow } from "../../../components/SpanWithAfterDownArrow";
import { HeaderTileContainer } from "../HeaderTileContainer";
import { HeaderTile } from "../../../components/HeaderTile";
import { ClubCatchHeader } from "../../../components/ClubCatchHeader";
import { fetcher } from "../../../api/index";
import { HEADER_LOYALTY_API } from "../../../consts/index";
import { BenefitBox } from "./BenefitBox";
import { jsx as ___EmotionJSX } from "@emotion/react";
var CTAButton = styled(LinkButton)(_templateObject());

var IconSpan = function IconSpan(props) {
  return ___EmotionJSX(Span, _extends({
    fontSize: "xs",
    fontWeight: 400,
    textAlign: "center"
  }, props));
};

export var ClubCatchTile = function ClubCatchTile(_ref) {
  var _loyaltyData$club, _loyaltyData$club2, _loyaltyData$club3, _loyaltyData$club4;

  var isLoggedIn = _ref.isLoggedIn,
      isCCMember = _ref.isCCMember;
  var theme = useTheme();

  var _useSWR = useSWR(HEADER_LOYALTY_API, fetcher),
      loyaltyResponse = _useSWR.data,
      isValidating = _useSWR.isValidating;

  var showClubCatchJoin = !isLoggedIn || !isCCMember;
  var loyaltyData = loyaltyResponse === null || loyaltyResponse === void 0 ? void 0 : loyaltyResponse.data;
  var hasBeenClubCatchMember = loyaltyData === null || loyaltyData === void 0 ? void 0 : (_loyaltyData$club = loyaltyData.club) === null || _loyaltyData$club === void 0 ? void 0 : _loyaltyData$club.hasBeenClubCatchMember;
  var renewalCartUrl = loyaltyData === null || loyaltyData === void 0 ? void 0 : (_loyaltyData$club2 = loyaltyData.club) === null || _loyaltyData$club2 === void 0 ? void 0 : _loyaltyData$club2.renewalCartUrl;
  var isFreeTrial = loyaltyData === null || loyaltyData === void 0 ? void 0 : (_loyaltyData$club3 = loyaltyData.club) === null || _loyaltyData$club3 === void 0 ? void 0 : _loyaltyData$club3.isFreeTrial;
  var freeTrialRemainingDuration = loyaltyData === null || loyaltyData === void 0 ? void 0 : (_loyaltyData$club4 = loyaltyData.club) === null || _loyaltyData$club4 === void 0 ? void 0 : _loyaltyData$club4.freeTrialRemainingDuration;

  var renderPopupContent = function renderPopupContent() {
    if (!showClubCatchJoin || isValidating) {
      return null;
    }

    return ___EmotionJSX(Flex, {
      width: "400px",
      flexDirection: "column",
      color: "typography.text",
      boxShadow: "0 2px 4px 0 rgba(0,0,0,0.50)",
      bg: "white"
    }, ___EmotionJSX(ClubCatchHeader, null, ___EmotionJSX(Text, {
      textStyle: "h3",
      m: "0",
      textAlign: "center",
      textTransform: "uppercase"
    }, hasBeenClubCatchMember ? "Join Club Catch Today" : "Start your 30-day free trial!"), ___EmotionJSX(Text, {
      m: "0",
      textAlign: "center"
    }, !hasBeenClubCatchMember ? ___EmotionJSX(React.Fragment, null, "After your free trial, Club Catch is only", ___EmotionJSX("br", null), "$6.50/month. Cancel anytime.") : ___EmotionJSX(React.Fragment, null, "Club Catch is only $6.50/month.", ___EmotionJSX("br", null), "Cancel anytime."))), ___EmotionJSX(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }, ___EmotionJSX(CTAButton, {
      block: false,
      mr: "0.875rem",
      sizeVariant: "sm",
      variant: "primary",
      href: hasBeenClubCatchMember ? renewalCartUrl : "/club-catch",
      "data-tracking": hasBeenClubCatchMember ? "header-app-club-catch-renew-club-catch" : "header-app-club-catch-join-club-catch"
    }, hasBeenClubCatchMember ? "Renew Membership" : "Join Club Catch"), ___EmotionJSX(Text, {
      textStyle: "h3",
      color: "brand.clubCatch",
      m: "0",
      lineHeight: "1"
    }, "Unlock amazing benefits"), ___EmotionJSX(Flex, {
      flexWrap: "wrap",
      width: "100%",
      p: "15px 15px 5px 15px"
    }, ___EmotionJSX(BenefitBox, {
      icon: ___EmotionJSX(IconClubCatchShipping, {
        title: "Free shipping with Club Catch",
        height: "36px",
        width: "auto"
      })
    }, "Free delivery on eligible products"), ___EmotionJSX(BenefitBox, {
      icon: ___EmotionJSX(IconClubCatchMonitor, {
        title: "Club Catch exclusive deals",
        height: "43px",
        width: "auto"
      })
    }, "Weekly exclusive deals"), ___EmotionJSX(BenefitBox, {
      icon: ___EmotionJSX(IconDiscountTag, {
        title: "Club Catch member discounts",
        height: "32px",
        width: "auto"
      })
    }, "1000's of member discounts"), ___EmotionJSX(BenefitBox, {
      icon: ___EmotionJSX(IconClubCatchMail, {
        title: "Free shipping with Club Catch",
        height: "36px",
        width: "auto"
      })
    }, "Early alerts")), ___EmotionJSX(Link, {
      href: "/club-catch-terms",
      fontSize: "2xs",
      m: "0",
      mb: "7px"
    }, "View Terms & Conditions")));
  };

  var renderClubCatchIcon = function renderClubCatchIcon() {
    return ___EmotionJSX(IconClubCatch, {
      verticalAlign: "top",
      height: "17px",
      width: "77px",
      title: "Club Catch"
    });
  };

  var renderIconContent = function renderIconContent() {
    if (!isLoggedIn || !isCCMember && !hasBeenClubCatchMember) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconSpan, null, "Free delivery"), ___EmotionJSX(SpanWithAfterDownArrow, {
        fontSize: "xs"
      }, "with ", renderClubCatchIcon()));
    } else if (isCCMember && isFreeTrial) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconSpan, null, renderClubCatchIcon()), ___EmotionJSX(IconSpan, null, "free trial expires in ", freeTrialRemainingDuration, " ", freeTrialRemainingDuration === 1 ? "day" : "days"));
    } else if (!isCCMember && hasBeenClubCatchMember) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconSpan, null, "Want free delivery?"), ___EmotionJSX(SpanWithAfterDownArrow, {
        fontSize: "xs",
        textAlign: "center",
        whiteSpace: "normal !important"
      }, "Renew ", renderClubCatchIcon()));
    }

    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconSpan, null, renderClubCatchIcon()), ___EmotionJSX(IconSpan, null, "Show me exclusive deals!"));
  };

  var getTileLinkProps = function getTileLinkProps() {
    var ariaLabel = "Club Catch shop";
    var href = "/shop/club-catch";

    if (isLoggedIn && !isCCMember && hasBeenClubCatchMember && renewalCartUrl) {
      ariaLabel = "Renew Club Catch membership";
      href = renewalCartUrl;
    }

    return {
      "aria-label": ariaLabel,
      href: href
    };
  };

  var renderIcon = function renderIcon(_ref2) {
    var _theme$colors, _theme$colors$clubCat;

    var isOpen = _ref2.isOpen;
    var iconStyleOnHover = {
      svg: {
        fill: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$clubCat = _theme$colors["clubCatch"]) === null || _theme$colors$clubCat === void 0 ? void 0 : _theme$colors$clubCat["primary"]
      }
    };

    var iconStyle = _objectSpread({
      "&:hover": iconStyleOnHover
    }, isOpen && {
      svg: iconStyleOnHover.svg
    });

    return ___EmotionJSX(HeaderTileContainer, {
      "data-testid": "club-catch-tile",
      hasRightBorder: true,
      flexProps: {
        px: "7px",
        maxWidth: "130px"
      },
      linkProps: _objectSpread({
        css: iconStyle,
        backgroundColor: isOpen ? "white" : undefined,
        color: isOpen ? "secondaryDark" : "white",
        className: "js-dnt",
        "data-tracking": "header-app-club-catch-tile"
      }, getTileLinkProps())
    }, ___EmotionJSX(Flex, {
      flexDirection: "column",
      alignItems: "center"
    }, renderIconContent()));
  };

  return ___EmotionJSX(HeaderTile, {
    popoverProps: {
      placement: "bottom"
    },
    icon: renderIcon
  }, renderPopupContent());
};
export default ClubCatchTile;